package com.bikompanion.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontVariation
import org.jetbrains.compose.resources.Font as ComposeFont

/**
 * Roboto Flex variable font tuned to the wordmark spec from the Google Fonts specimen:
 * Optical Size Auto, Slant -4, Width 151, Weight 400, Grade -3, Thick Stroke 144, Counter Width
 * 468, Thin Stroke 111, Descender Depth -203, Figure Height 738, Lowercase Height 514, Uppercase
 * Height 712.
 */
@Composable
fun rememberTitleFontFamily(): FontFamily {
    val font = ComposeFont(
        resource = Res.font.roboto_flex,
        variationSettings = FontVariation.Settings(
            FontVariation.Setting("slnt", -4f),
            FontVariation.Setting("wdth", 151f),
            FontVariation.Setting("wght", 400f),
            FontVariation.Setting("GRAD", -3f),
            FontVariation.Setting("XOPQ", 144f),
            FontVariation.Setting("XTRA", 468f),
            FontVariation.Setting("YOPQ", 111f),
            FontVariation.Setting("YTDE", -203f),
            FontVariation.Setting("YTFI", 738f),
            FontVariation.Setting("YTLC", 514f),
            FontVariation.Setting("YTUC", 712f),
        ),
    )
    return remember(font) { FontFamily(font) }
}
